import React, { type ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Alert, Button } from 'antd';

import logout from '../helpers/logout';

type RootState = {
  login: { login: string | null; impersonatedBy?: { userId: number; login: string } | null };
};

/** Keeps a platform admin who signed in as a user aware that every action is taken as that user. */
export default function ImpersonationBanner(): ReactElement | null {
  const { login, impersonatedBy } = useSelector((state: RootState) => state.login);

  if (!impersonatedBy) return null;

  return (
    <Alert
      banner
      type="warning"
      title={
        <>
          You are signed in as <strong>{login}</strong> by platform admin <strong>{impersonatedBy.login}</strong>.
          Everything you do is done as this user.
        </>
      }
      action={
        <Button size="small" danger onClick={logout}>
          End session
        </Button>
      }
    />
  );
}
